'use strict';

var symbols = require('./constants').symbols;

module.exports = function getCurrencySymbol(currencyENUM) {
    return symbols[currencyENUM];
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-currency-helpers/getCurrencySymbol.js
// module id = ./node_modules/dibs-currency-helpers/getCurrencySymbol.js
// module chunks = 4